function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useEffect, useRef } from 'react';
import Button from '../Button';
import browserAgent from '../../common/utils/browserAgent';

const PreventDragButton = ({
  as: Component = Button,
  children,
  onPointerDown,
  ...props
}) => {
  const ref = useRef(null);
  useEffect(() => {
    const callback = onPointerDown || (event => event.stopPropagation());

    const eventListener = browserAgent.mobile ? 'touchstart' : 'pointerdown';
    ref.current?.addEventListener(eventListener, callback);
    return () => ref.current?.removeEventListener(eventListener, callback);
  }, [onPointerDown]);
  return /*#__PURE__*/React.createElement(Component, _extends({
    ref: ref
  }, props), children);
};

export default PreventDragButton;